funnies = {
  errorTitle: [
    'Big oof.'
    'Houston, we\'ve got a problem'
    'Whoops!'
    'We\'re sorry...'
  ]
  upload: [
    'Uploading fluff to the clunk expander...'
    'Sending the USB strapped pigeon...'
  ]
  init: [
    'Putting on the pants, one leg at a time...'
    'Strapping a USB-stick to a pigeon...'
    'Lacing the shoes...'
    'Constructing additional pylons...'
    'Stuffing data into canon...'
  ]
  pending: [
    'We\'re still waiting for dave...'
    'Whistling moronically...'
  ]
  progress: [
    'Find a hat and hold onto it...'
    'Please be patient while we iron the shirts...'
  ]
  done: [
    'Fluff successfully clunked.'
    'We totally expected it to succeed though.'
    'Please excuse us while we pat ourselves on the back.'
  ]
}

export getRandomUpload = ->
  _.sample(funnies.upload)

export getRandomErrorTitle = ->
  _.sample(funnies.errorTitle)

export getRandomInit = ->
  _.sample(funnies.init)

export getRandomPending = ->
  _.sample(funnies.pending)

export getRandomProgress = ->
  _.sample(funnies.progress)

export getRandomDone = ->
  _.sample(funnies.done)

export default funnies
